import moment from 'moment-timezone';
import cookie from 'cookie';

import { countries as countriesObj } from './countries';

moment.tz.setDefault('Asia/Bangkok');

export function isMobile() {
  if (
    global
    && global.navigator
    && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      global.navigator.userAgent
    )
  ) {
    // Client side only
    return true;
  }
  return false;
}

export function isServiceTime(start = '10', end = '20') {
  const hr = moment().format('HH');
  if (hr >= start && hr < end) {
    return true;
  }
  return false;
}

export function getInstantUrl() {
  if (isServiceTime('06', '20')) {
    return '/to/Any?date=tomorrow&is_instant=true';
  }
  if (isServiceTime('20', '22')) {
    return '/inspiration/book-today-travel-tomorrow-joined-tour';
  }
  return null;
}

// export function isMobileScreen() {
//   if (window && window.innerWidth <= 700) {
//     return true;
//   }
//   return false;
// }

// export function getTripLabels(trip) {
//   const labels = [];
//   if (trip.price_condition.text === 'All inclusive') {
//     labels.push({
//       text: 'All inclusive',
//       style: 'tag-inclusive',
//       templateId: 'trip.item.all_inclusive',
//     });
//   }
//   // if (trip.transportation === 'Private Car') {
//   //   labels.push({text: 'Private car', style: 'tag-transport'});
//   // }
//   if (trip.search_information.is_hotel_pickup) {
//     labels.push({
//       text: 'Free hotel pickup',
//       style: 'tag-pickup',
//       templateId: 'trip.item.free_hotel_pickup',
//     });
//   }
//   // if (trip.tmt_tag) {
//   //   labels.push({text: 'Exclusively', style: 'tag-tmt'});
//   // }
//   return labels;
// }

export function capitalizeFirstLetter(string = '') {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function commaizeInt(num) {
  return ((num && Math.ceil(num)) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function commaize(num, currency) {
  if (['JPY', 'KRW'].includes(currency)) return commaizeInt(num);
  return (num || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getResponse(response) {
  const time = `About ${moment
    .duration(response.average_time || 10800, 'seconds')
    .humanize()}`;
  const rate = `${((response.rate || 1) * 100).toFixed(0)}%`;
  return { time, rate };
}
export function getDisplayPrice(quantity, fullPrices, omitBookingFee = false) {
  let price = 0;
  if (Array.isArray(fullPrices)) {
    fullPrices.forEach((fp, index) => {
      if (index <= quantity - 1) {
        price = omitBookingFee
          ? fp.seasonedDiscountedPerPerson
          : fp.displayPrice;
      }
    });
  } else {
    price = omitBookingFee
      ? fullPrices.seasonedDiscountedPerPerson
      : fullPrices.displayPrice;
  }
  return price;
}

export function getDisplaySeasonedPrice(
  quantity,
  fullPrices,
  omitBookingFee = false
) {
  let price = 0;
  if (Array.isArray(fullPrices)) {
    fullPrices.forEach((fp, index) => {
      if (index <= quantity - 1) {
        price = omitBookingFee ? fp.seasoned : fp.displaySeasonedPrice;
      }
    });
  } else {
    price = omitBookingFee
      ? fullPrices.seasoned
      : fullPrices.displaySeasonedPrice;
  }
  return price;
}

export const getRatingPoint = rating => parseFloat(rating.toFixed(1), 10);

export function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'); // eslint-disable-line
}
export function stripLink(html, link) {
  if (!html) return null;
  const match = html.match(/<a.*?>(.*?)<\/a>/gim);
  let out = html;
  if (match) {
    match.map(m => {
      out = out.replace(
        new RegExp(m, 'gm'),
        m.replace(new RegExp(`<a.*?href="${escapeRegExp(decodeURI(link))}".*?>(.*?)</a>`, 'gmi'), '$1')
      );
      return null;
    });
  }
  return out;
}

export function getCity(path = 'Bangkok') {
  return unescape(path);
}
// export function isOtherCities(city) {
//   const cities = [
//     'Bangkok',
//     'Chiang Mai',
//     'Phuket',
//     'Other',
//     'Tokyo',
//     'Kanagawa',
//   ];
//   if (city === 'Other' || cities.indexOf(city) < 0) {
//     return true;
//   }
//   return false;
// }

// export function getID(type) {
//   const types = [
//     'famous-attractions',
//     'real-local-experience',
//     'meet_local_people',
//   ];
//   return types.indexOf(type) + 1;
// }

export function getHeadTagKey(type) {
  switch (type) {
    case 'famous-attractions':
      return 'topic';
    case 'local-experiences':
      return 'trip';
    case 'local-experts':
      return 'lx';
    default:
      return null;
  }
}

export function getTitleTag(tagType, location, headTags) {
  if (
    headTags
    && headTags[location]
    && headTags[location][`${tagType}_title`]
  ) {
    return headTags[location][`${tagType}_title`];
  }
  if (tagType === 'topic') {
    return `Book Private Tour to ${location === 'Other' ? '44 more cities' : location} with TakeMeTour`;
  }
  if (tagType === 'trip') {
    return `${location === 'Other' ? 'Thailand' : location}'s Local & Authentic Day Trips with Local Experts | Book Today on TakeMeTour.com`;
  }
  if (tagType === 'lx') {
    return `Personal Day Trips into One Day of Local Life | Local Experts in ${location === 'Other' ? '44 more cities' : location}`;
  }
  return '';
}

export function getDescriptionTag(tagType, location, headTags) {
  if (
    headTags
    && headTags[location]
    && headTags[location][`${tagType}_description`]
  ) {
    return headTags[location][`${tagType}_description`];
  }
  if (tagType === 'topic') {
    return `Capture famous sightseeing spots in ${location === 'Other' ? '44 more cities' : location} with TakeMeTour's Local Experts. Private and Personal experiences guaranteed! `;
  }
  if (tagType === 'trip') {
    return `Enjoy local experiences in ${location === 'Other' ? '44 more cities' : location} with the local experts! Make your visit unique, flexible and personal!`;
  }
  if (tagType === 'lx') {
    return `Make your trip to ${location === 'Other' ? '44 more cities' : location} truly memorable by learning local cultures side-by-side with the local experts!`;
  }
  return '';
}

export function getH1(tagType, location, headTags) {
  if (headTags && headTags[location] && headTags[location][`${tagType}_h1`]) {
    return headTags[location][`${tagType}_h1`];
  }
  if (tagType === 'topic') {
    return `Famous Attraction in ${location === 'Other' ? '44 More Cities' : location}`;
  }
  if (tagType === 'trip') {
    return `Local Experiences in ${location === 'Other' ? '44 More Cities' : location}`;
  }
  if (tagType === 'lx') {
    return `Local Experts in ${location === 'Other' ? '44 More Cities' : location}`;
  }
  return '';
}

export const countries = countriesObj.map(c => c.label);

export const days = Array(31).fill(0).map((data, index) => {
  return 1 + index;
});
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const years = Array(80).fill(0).map((data, index) => {
  return 1930 + index;
});

export const hours = [
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
];
export const minutes = ['00', '15', '30', '45'];

export function getHour(time) {
  return time.split(':')[0];
}
export function getMinute(time) {
  return time.split(':')[1];
}


export function addStringTime(startTime, _addTime) {
  const addTime = _addTime.toString();
  const addHour = addTime.includes(':') ? getHour(addTime) : addTime;
  const addMin = addTime.includes(':') ? getMinute(addTime) : '00';
  const endHour = Number(getHour(startTime)) + Number(addHour);
  const endMinute = Number(getMinute(startTime)) + Number(addMin); // getMinute(startTime);
  let processingHour = endHour;
  let newDay = false;

  // calculate min
  let processingMin = endMinute;
  if (processingMin < 10) {
    processingMin = `0${processingMin}`;
  } else if (processingMin >= 60) {
    processingMin = `0${processingMin - 60}`;
    processingHour += 1;
  }

  // calculate hour
  if (processingHour < 10) {
    processingHour = `0${processingHour}`;
  } else if (processingHour >= 24) {
    processingHour = `0${processingHour - 24}`;
    newDay = true;
  }
  const endTime = `${processingHour}:${processingMin}`;
  return {
    time: endTime,
    newDay
  };
}

export const currencies = [
  { value: 'USD', label: 'US Dollar' },
  { value: 'EUR', label: 'EU Euro' },
  { value: 'GBP', label: 'British Pound' },
  { value: 'CNY', label: 'Chinese Yuan' },
  { value: 'KRW', label: 'Korean Won' },
  { value: 'JPY', label: 'Japanese Yen' },
  { value: 'SGD', label: 'Singapore Dollar' },
  { value: 'AUD', label: 'Australian Dollar' },
  { value: 'HKD', label: 'Hongkong Dollar' },
  { value: 'SEK', label: 'Swedish Krona' },
  { value: 'NOK', label: 'Norwegian Krone' },
  { value: 'CHF', label: 'Swiss Franc' },
  { value: 'RUB', label: 'Russian Ruble' },
  { value: 'MYR', label: 'Malaysian Ringgit' },
  { value: 'THB', label: 'Thai Baht' },
];

export const isDusitApp = () => {
  if (!global.window || !global.window.document) return false;
  return cookie.parse(window.document.cookie).utm_campaign === 'Dusit app';
};

export const getCookie = key => {
  if (!global.window || !global.window.document) return null;
  return cookie.parse(window.document.cookie)[key];
};

export const createDateArray = date => [{ date: moment(date) }];

export const calculateTripPrice = (prices, quantity, childPrice = 0, childQuantity = 0) => {
  return ((prices[quantity - 1] || 0) * quantity) + (childPrice * childQuantity);
};

export const calculateMultiTierPrice = (selectedTier, field = 'price') => {
  return selectedTier.sub_tiers.reduce((prev, curr) => prev + (curr.quantity * (curr[field] || curr.price)), 0);
};

export function cleanTag(str) {
  return (str || '').replace(/<\/?[^>]+(>|$)/g, '');
}

export const transferTime = [
  '00:00',
  '00:15',
  '00:30',
  '00:45',
  '01:00',
  '01:15',
  '01:30',
  '01:45',
  '02:00',
  '02:15',
  '02:30',
  '02:45',
  '03:00',
  '03:15',
  '03:30',
  '03:45',
  '04:00',
  '04:15',
  '04:30',
  '04:45',
  '05:00',
  '05:15',
  '05:30',
  '05:45',
  '06:00',
  '06:15',
  '06:30',
  '06:45',
  '07:00',
  '07:15',
  '07:30',
  '07:45',
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
  '17:15',
  '17:30',
  '17:45',
  '18:00',
  '18:15',
  '18:30',
  '18:45',
  '19:00',
  '19:15',
  '19:30',
  '19:45',
  '20:00',
  '20:15',
  '20:30',
  '20:45',
  '21:00',
  '21:15',
  '21:30',
  '21:45',
  '22:00',
  '22:15',
  '22:30',
  '22:45',
  '23:00',
  '23:15',
  '23:30',
  '23:45'
];
